import { CaixaProps } from "../../components/Estrutura/Caixa";

export const equipamentosGravacao: CaixaProps[] = [
  {
    nome: "Mesa de som Behringer Eudodesk MX8000",
    descricao: "Mesa de som analógica de 24 canais",
    img: "/assets/Estudio/IMG_4349.jpg",
  },
  {
    nome: "Microfone Condensador AKG C214",
    descricao: "Microfone de estúdio para gravação vocal",
    img: "/assets/Estudio/akg_c214.jpg",
  },
  {
    nome: "Microfone condensador Neumann TLM 103",
    descricao: "Microfone de estúdio de altíssima qualidade",
    img: "/assets/Estudio/IMG_4391.jpg",
  },
  {
    nome: "Microfones de bateria",
    descricao: "-",
    img: "",
  },
  {
    nome: "Equiapamentos de gravação",
    descricao: "-",
    img: "/assets/Estudio/IMG_8919.jpg",
  },
  {
    nome: "Par de Monitores Yamaha NS-10M Studio",
    descricao: "Monitores de estúdio",
    img: "/assets/Estudio/IMG_4347.jpg",
  }, //Behringer X1204USB Xenyx
  {
    nome: "Mesa de som Behringer X1204USB Xenyx",
    descricao: "Mesa de som analógica de 12 canais",
    img: "",
  },
];
